import { AsyncPipe, DecimalPipe } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InstrumentDetailsService } from '@zero/instrument-details/domain';
import { Product } from '@zero/onboarding/domain';
import { TradingViewChartWebComponent } from '@zero/shared/charts/ui-charts-web';
import { IconComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { TelekursPeriod } from '@zero/shared/util-models';

@Component({
  standalone: true,
  imports: [ModalComponent, TranslocoPipe, IconComponent, NgbTooltipModule, TradingViewChartWebComponent, AsyncPipe, DecimalPipe],
  templateUrl: './product-info.component.html',
  styleUrl: './product-info.component.scss',
})
export class ProductInfoComponent implements OnInit {
  public readonly product = input<Product>();

  public readonly modal = inject(NgbActiveModal);
  public readonly service = inject(InstrumentDetailsService);

  async ngOnInit(): Promise<void> {
    await this.service.loadInstrument(this.product()?.isin);
    this.service.changeChartPeriod(TelekursPeriod.TwoYears);
  }
}
